module.exports = __webpack_public_path__ + "static/media/anuncio-discrecional.ec7af814.jpg";